var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationBuilding = function SvgSimpleIllustrationBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__building_svg__Layer_1",
    viewBox: "0 0 68 68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".simple-illustration__building_svg__st2{stroke:#002140;stroke-linejoin:round;fill:none}.simple-illustration__building_svg__st4{fill:#002140}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd7b0",
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round"
    },
    d: "M23 10h28v48H23z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 30,
    y: 15,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 30,
    y: 26,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 30,
    y: 37,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 40,
    y: 15,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 40,
    y: 26,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 40,
    y: 37,
    className: "simple-illustration__building_svg__st4",
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round",
      fill: "#ffa75a"
    },
    d: "M15 10h8v48h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8dc8ff",
      strokeLinecap: "round",
      stroke: "#002140",
      strokeLinejoin: "round"
    },
    d: "M29 50h18v8H29z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 50v8M41 50v8",
    className: "simple-illustration__building_svg__st2"
  })));
};
export default SvgSimpleIllustrationBuilding;